/**
 * runtimeConfig - all runtime configuration for app is to be read here.
 * Eg: maintenance settings, API keys, service URLs, and OpenTelemetry settings.
 * The config is used throughout the application to determine behavior and access external services.
 * @returns An object containing the runtime configuration.
 */

import uiitemmaintainMfeConfig from 'uiitemmaintainMfeConfig'

type ServiceConfig = {
  baseUrl?: string
  routes?: Record<string, string>
}

const mfeConfig = uiitemmaintainMfeConfig ?? {}

/**
 * Returns the runtime configuration for the application, including maintenance settings, API keys, service URLs, and OpenTelemetry settings.
 * This configuration is derived from the MFE configuration provided by the host application.
 * @returns An object containing the runtime configuration.
 */
export const runtimeConfig = {
  maintenance: {
    enabled: Boolean(mfeConfig?.maintenance?.enabled),
  },
  api: {
    apiKey: mfeConfig?.api?.apiKey ?? '',
  },
  services: {
    graphql: {
      url: mfeConfig?.services?.graphql?.url ?? '',
    },
  },
  openTelemetry: {
    apiKey: mfeConfig?.openTelemetry?.apiKey ?? '',
    serviceName: mfeConfig?.openTelemetry?.serviceName ?? '',
    enabled: Boolean(mfeConfig?.openTelemetry?.enable),
  },
}

/**
 * Returns the full URL for a given service and route based on the configuration.
 * @param serviceName The name of the service.
 * @param route The specific route within the service.
 * @returns The full URL for the specified service and route.
 */
export const getServiceUrl = (serviceName: string, route: string): string => {
  const serviceConfig = mfeConfig?.services?.[serviceName] as
    | ServiceConfig
    | undefined
  const baseUrl = serviceConfig?.baseUrl ?? ''
  const serviceUrl = serviceConfig?.routes?.[route] ?? ''
  return `${baseUrl}${serviceUrl}`
}
